export default __webpack_public_path__ + "static/media/expert_advice_img.05622478.png";